import React, { useEffect, useState } from "react";
import AyurHeader from "../components/AYHeader";
import AyurFooter from "../components/AYFooter";

// import "./../assets/AyurvedaAssets/css/bootstrap.min.css";
// import "./../assets/AyurvedaAssets/css/animate.css";
// import "./../assets/AyurvedaAssets/css/all.min.css";
// import "./../assets/AyurvedaAssets/css/fontello.css";
// import "./../assets/AyurvedaAssets/css/flaticon.css";
// import "./../assets/AyurvedaAssets/css/themify-icons.css";
// import "./../assets/AyurvedaAssets/css/font-awesome.css";
// import "./../assets/AyurvedaAssets/css/aos.css";
// import "./../assets/AyurvedaAssets/css/slick.css";
// import "./../assets/AyurvedaAssets/css/prettyPhoto.css";
// import "./../assets/AyurvedaAssets/css/samarkannormal.css";
// import "./../assets/AyurvedaAssets/css/shortcodes.css";
// import "./../assets/AyurvedaAssets/css/main.css";
// import "./../assets/AyurvedaAssets/css/megamenu.css";
// import "./../assets/AyurvedaAssets/css/responsive.css";
// import "./../assets/AyurvedaAssets/css/custombharat.css";

const cssFiles = [
  "/assets/AyurvedaAssets/css/bootstrap.min.css",
  "/assets/AyurvedaAssets/css/animate.css",
  "/assets/AyurvedaAssets/css/all.min.css",
  "/assets/AyurvedaAssets/css/fontello.css",
  "/assets/AyurvedaAssets/css/flaticon.css",
  "/assets/AyurvedaAssets/css/themify-icons.css",
  "/assets/AyurvedaAssets/css/font-awesome.css",
  "/assets/AyurvedaAssets/css/aos.css",
  "/assets/AyurvedaAssets/css/slick.css",
  "/assets/AyurvedaAssets/css/prettyPhoto.css",
  "/assets/AyurvedaAssets/css/samarkannormal.css",
  "/assets/AyurvedaAssets/css/shortcodes.css",
  "/assets/AyurvedaAssets/css/main.css",
  "/assets/AyurvedaAssets/css/megamenu.css",
  "/assets/AyurvedaAssets/css/responsive.css",
  "/assets/AyurvedaAssets/css/custombharat.css",
];

export default function AyurThemeLayout({
  children,
  menuWrapperRef,
  menuContentRef,
  serviceLinks,
  treatmentLinks,
  production,
}) {
  const [cssLoaded, setCssLoaded] = useState(false);

  useEffect(() => {
    let loadedCount = 0;
    const links = cssFiles.map((href) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.dataset.theme = "ayurveda";

      // Increment counter when each CSS finishes loading
      link.onload = () => {
        loadedCount++;
        if (loadedCount === cssFiles.length) {
          setCssLoaded(true);
        }
      };

      document.head.appendChild(link);
      return link;
    });

    // Cleanup on unmount
    return () => {
      links.forEach((link) => link.remove());
    };
  }, []);

  // Don't render children until CSS is fully loaded
  if (!cssLoaded) {
    return <div style={{ visibility: "hidden" }}>Loading...</div>;
  }
  return (
    <>
      <div className="page">
        <div className="main-box">
          <AyurHeader
            menuWrapperRef={menuWrapperRef}
            menuContentRef={menuContentRef}
            serviceLinks={serviceLinks}
            treatmentLinks={treatmentLinks}
          />
          <main>{children}</main>
          <AyurFooter
            menuWrapperRef={menuWrapperRef}
            menuContentRef={menuContentRef}
            production={production}
          />
        </div>
      </div>
    </>
  );
}
